import React from "react";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {TableSortLabel} from "@mui/material";
import {TableStyle} from "../../../../styles/components/TableStyle";


const CustomHead = ({
	                    rows,
	                    onRequestSort,
	                    orderBy,
	                    order,
	                    showDetailButton = false,
	                    showSollecita = false,
	                    detailText = "Dettagli"
                    }) => {
	const classes = TableStyle()
	
	const createSortHandler = (property) => (event) => {
		onRequestSort(event, property);
	};
	
	return (
		<TableHead>
			<TableRow>
				{rows.map((headCell, key) => (
					<TableCell
						className={classes.cell}
						key={key}
						align={key === (rows.length - 1) ? "center" : "left"}
						sortDirection={orderBy === headCell.id ? order : false}
					>
						<TableSortLabel
							active={orderBy === headCell.id}
							direction={orderBy === headCell.id ? order : "asc"}
							onClick={createSortHandler(headCell.id)}
						>
							<b>{headCell.label}</b>
							{orderBy === headCell.id ? (
								<span className={classes.visuallyHidden}>
                  {order === "desc"
	                  ? "sorted descending"
	                  : "sorted ascending"}
                </span>
							) : null}
						</TableSortLabel>
					</TableCell>
				))}
				{showSollecita && (
					<TableCell className={classes.cell} align={"center"}>
						<b>Sollecita</b>
					</TableCell>
				)}
				{showDetailButton && (
					<TableCell className={classes.cell} align={"center"}>
						<b>{detailText}</b>
					</TableCell>
				)}
			</TableRow>
		</TableHead>
	);
}

export default React.memo(CustomHead)
